export const GENERIC_ERROR_MESSAGE = "Something went wrong, please refresh the page and try again.";
